// @ts-nocheck
import { useCallback, useEffect, useState } from "react";
import { cleanText, clientApi, getTypeQuestionnaires, sanitizeURL, sanitizeData, validateUrl } from "~/utils";
import { postDraftAttachmentsDetails as postDraftAttachmentsDetailsPartner } from "~/pages/questionnaires/v1/partner/api/apiMethods";
import { AttachmentsDetailsError, ClientId, FileTypeEnum, NamesOfFieldEnum, OrgTypeEnum, QuestionnaireTypeEnum } from "~/typings/types";

import { useUploadLogoFile, useUploadPassportFile } from ".";
import { postDraftAttachmentsDetails as postDraftAttachmentsDetailsCustomer } from "../../v2/customer/api/apiMethods";
import { useAcceptPolitics } from "../accept-politics/AcceptPoliticsContext";

const fetchFileById = (fileId: any, setFiles: any, setFileIds: any, clientId: ClientId) => {
  const id = Array.isArray(fileId)
    ? fileId.length > 0 ? fileId[0] : null
    : fileId;

  if (id) {
    clientApi
      .get(`/api/questionnaire/v1/helper/file/?file_id=${cleanText(id)}&id=${clientId}`)
      .then(res => {
        setFiles((prev: any) => [
          ...prev,
          new File([], res.data.data.filename_original),
        ]);
        setFileIds((prev: any) => [...prev, res.data.data.file_id]);
      });
  }
};

const UPLOADED_FILE_PLACEHOLDER = "Документ загружен";

const setUploadedFilePlaceholder = (fileId: any, setFiles: any, setFileIds: any) => {
  const id = Array.isArray(fileId) ? fileId[0] : fileId;
  setFiles([new File([], UPLOADED_FILE_PLACEHOLDER)]);
  setFileIds([Number(id)]);
};

// Функия для валидации которая приходит с бека, если приходит ошибки то показываем ошибку под Файламм
const getErrorAttachmentDetails = (
  dataError: any,
  setErrors: Record<string, (error: { has: 1; message: string }) => void>
) => {
  if (!Array.isArray(dataError) || dataError.length === 0) {
    return;
  }

  const isPartnerTypeQuestionnaires = getTypeQuestionnaires() === "partner";

  const fieldErrorMap: Record<string, string> = {
    [NamesOfFieldEnum.LogoFileId]: "setLogoError",
    [NamesOfFieldEnum.PassportFileId]: "setPassportError",
    [NamesOfFieldEnum.DocumentAgreement1FileId]: "setDocumentAgreement1Error",
    [NamesOfFieldEnum.DocumentAgreement2FileId]: "setDocumentAgreement2Error",
    [NamesOfFieldEnum.DocumentPricesTariffsFileId]: "setDocumentPricesTariffsError",
    [NamesOfFieldEnum.PassportMainFileId]: "setPassportMainFilesError",
    [NamesOfFieldEnum.PassportRegistrationFileId]: "setPassportRegistrationFilesError",
    [NamesOfFieldEnum.DocumentPricesTariffsLink]: "setPricesTariffsLinkError",
    [NamesOfFieldEnum.IsOffertAccepted]: "setAcceptPoliticsError",
    [NamesOfFieldEnum.IsPrivacyAccepted]: "setAcceptPrivacyError",
    [NamesOfFieldEnum.IsPromoAccepted]: "setAcceptPromoError",
  };

  dataError.forEach((error: any) => {
    const fieldName = error.data.target;
    const setterKey = fieldErrorMap[fieldName];

    if (setterKey && setErrors[setterKey]) {
      setErrors[setterKey]({ has: 1, message: sanitizeData(error.message) });
    }

    if (isPartnerTypeQuestionnaires) {
      if (fieldName === NamesOfFieldEnum.PassportMainFileId) {
        setErrors["setLogoError"]?.({ has: 1, message: sanitizeData(error.message) });
      }
      if (fieldName === NamesOfFieldEnum.PassportRegistrationFileId) {
        setErrors["setPassportError"]?.({ has: 1, message: sanitizeData(error.message) });
      }
    }
  });
};

type UseAttachmentsDetails = {
  clientId: ClientId;
  orgType: OrgTypeEnum;
  initialLogoFileId?: number[];
  initialPassportFileId: number[];
  initialPassportMainFileId: number[];
  initialPassportRegistrationFileId: number[];
  initialDocumentAgreement1FileId: number[];
  initialDocumentAgreement2FileId: number[];
  initialDocumentPricesTariffsFileId: number[];
  urlHelperFile: string;
  textLinkAttachment?: string;
};

export const useAttachmentsDetails = ({
  clientId,
  orgType,
  initialLogoFileId,
  initialPassportFileId,
  initialPassportMainFileId,
  initialPassportRegistrationFileId,
  initialDocumentAgreement1FileId,
  initialDocumentAgreement2FileId,
  initialDocumentPricesTariffsFileId,
  urlHelperFile,
  textLinkAttachment,
}: UseAttachmentsDetails) => {
  const {
    isAcceptPolitics,
    isAcceptPrivacy,
    isAcceptPromo,
    setAcceptPoliticsError,
    setAcceptPrivacyError,
    setAcceptPromoError
  } = useAcceptPolitics();

  /** Запрашиваем сохранненые файлы ранее при маунте компонента и получаем id файлов */
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    setIsLoading(true);
    Promise.allSettled([
      initialLogoFileId?.[0] &&
      clientApi
        .get(`/api/questionnaire/v1/helper/file/?file_id=${cleanText(initialLogoFileId[0])}&include_data=1&id=${clientId}`)
        .then(res => {
          setLogoFiles(prev => [...prev, new File([], res.data.data.filename_original)]);
          setLogoFileId(prev => [...prev, res.data.data.file_id]);
          setLogoData(res.data.data?.data);
        }),

      (initialLogoFileId != null && !(Array.isArray(initialLogoFileId) && initialLogoFileId?.length == 0)) &&
      clientApi
        .get(`/api/questionnaire/v1/helper/file/?file_id=${cleanText(initialLogoFileId)}&include_data=1&id=${clientId}`)
        .then(res => {
          setLogoFiles(prev => [...prev, new File([], res.data.data.filename_original)]);
          setLogoFileId(prev => [...prev, res.data.data.file_id]);
          setLogoData(res.data.data?.data);
        }),

      (initialPassportMainFileId != null && !(Array.isArray(initialPassportMainFileId) && initialPassportMainFileId?.length == 0)) &&
      (isPartnerTypeQuestionnaires
        ? setUploadedFilePlaceholder(initialPassportMainFileId, setPassportMainFiles, setPassportMainFileId)
        : clientApi
          .get(`/api/questionnaire/v1/helper/file/?file_id=${cleanText(initialPassportMainFileId)}&id=${clientId}`)
          .then(res => {
            setPassportMainFiles(prev => [...prev, new File([], res.data.data.filename_original)]);
            setPassportMainFileId(prev => [...prev, res.data.data.file_id]);
          })),

      (initialPassportRegistrationFileId != null && !(Array.isArray(initialPassportRegistrationFileId) && initialPassportRegistrationFileId?.length == 0)) &&
      (isPartnerTypeQuestionnaires
        ? setUploadedFilePlaceholder(initialPassportRegistrationFileId, setPassportRegistrationFiles, setPassportRegistrationFileId)
        : clientApi
          .get(`/api/questionnaire/v1/helper/file/?file_id=${cleanText(initialPassportRegistrationFileId)}&id=${clientId}`)
          .then(res => {
            setPassportRegistrationFiles(prev => [...prev, new File([], res.data.data.filename_original)]);
            setPassportRegistrationFileId(prev => [...prev, res.data.data.file_id]);
          })),
      fetchFileById(
        initialDocumentAgreement1FileId,
        setDocumentAgreement1Files,
        setDocumentAgreement1FileId,
        clientId
      ),
      fetchFileById(
        initialDocumentAgreement2FileId,
        setDocumentAgreement2Files,
        setDocumentAgreement2FileId,
        clientId
      ),
      fetchFileById(
        initialDocumentPricesTariffsFileId,
        setDocumentPricesTariffsFiles,
        setDocumentPricesTariffsFileId,
        clientId
      )
    ]).finally(() => setIsLoading(false));
  }, []);
  /** ------ end ------ */

  /** ------ Отправляем файл на сервер после загрузки <input type="file" /> ------ */
  const [logoFiles, setLogoFiles] = useState<File[]>([]);
  const [logoData, setLogoData] = useState('');
  const [documentAgreement1Files, setDocumentAgreement1Files] = useState<File[]>([]);
  const [documentAgreement2Files, setDocumentAgreement2Files] = useState<File[]>([]);
  const [documentPricesTariffsFiles, setDocumentPricesTariffsFiles] = useState<File[]>([]);
  const [passportFiles, setPassportFiles] = useState<File[]>([]);
  const [passportMainFiles, setPassportMainFiles] = useState<File[]>([]);
  const [passportRegistrationFiles, setPassportRegistrationFiles] = useState<File[]>([]);
  const [logoError, setLogoError] = useState<AttachmentsDetailsError>(null);
  const [documentAgreement1Error, setDocumentAgreement1Error] = useState<AttachmentsDetailsError>(null);
  const [documentAgreement2Error, setDocumentAgreement2Error] = useState<AttachmentsDetailsError>(null);
  const [documentPricesTariffsError, setDocumentPricesTariffsError] = useState<AttachmentsDetailsError>(null);
  const [passportMainFilesError, setPassportMainFilesError] = useState<AttachmentsDetailsError>(null);
  const [passportRegistrationFilesError, setPassportRegistrationFilesError] = useState<AttachmentsDetailsError>(null);
  const [passportError, setPassportError] = useState<AttachmentsDetailsError>(null);
  const [isFirstLoadingFile, setIsFirstLoadingFile] = useState(false); // Флаг который изменятся когда происходит хоть одно с действием с файлами, удаление/добавление
  const [pricesTariffsLinkError, setPricesTariffsLinkError] = useState<AttachmentsDetailsError>(null);

  const isErrorAttachmentsDetails = Boolean(logoError) || Boolean(passportError) || Boolean(documentAgreement1Error) || Boolean(documentAgreement2Error) || Boolean(documentPricesTariffsError) || Boolean(passportMainFilesError) || Boolean(passportRegistrationFilesError);

  const {
    filesId: logoFileId,
    setFilesId: setLogoFileId,
    isLoading: isLoadingUploadLogoFile
  } = useUploadLogoFile({ logoFiles, setLogoError, setIsFirstLoadingFile, urlHelperFile, setLogoFiles });

  const {
    filesId: documentAgreement1FileId,
    setFilesId: setDocumentAgreement1FileId,
    isLoading: isLoadingUploadDocumentAgreement1File
  } = useUploadLogoFile({ logoFiles: documentAgreement1Files, setLogoError: setDocumentAgreement1Error, setIsFirstLoadingFile, urlHelperFile, setLogoFiles: setDocumentAgreement1Files });

  const {
    filesId: documentAgreement2FileId,
    setFilesId: setDocumentAgreement2FileId,
    isLoading: isLoadingUploadDocumentAgreement2File
  } = useUploadLogoFile({ logoFiles: documentAgreement2Files, setLogoError: setDocumentAgreement2Error, setIsFirstLoadingFile, urlHelperFile, setLogoFiles: setDocumentAgreement2Files });

  const {
    filesId: documentPricesTariffsFileId,
    setFilesId: setDocumentPricesTariffsFileId,
    isLoading: isLoadingUploadDocumentPricesTariffsFile
  } = useUploadLogoFile({ logoFiles: documentPricesTariffsFiles, setLogoError: setDocumentPricesTariffsError, setIsFirstLoadingFile, urlHelperFile, setLogoFiles: setDocumentPricesTariffsFiles });

  const {
    filesId: passportFileId,
    setFilesId: setPassportFileId,
    isLoading: isLoadingUploadPassportFile
  } = useUploadPassportFile({
    passportFiles,
    setPassportError,
    setIsFirstLoadingFile,
    urlHelperFile,
    setPassportFiles
  });

  const questionnaireTypeForFileUpload = getTypeQuestionnaires() === "partner"
    ? QuestionnaireTypeEnum.RuPartner
    : QuestionnaireTypeEnum.RuCustomer;

  const {
    filesId: passportMainFileId,
    setFilesId: setPassportMainFileId,
    isLoading: isLoadingPassportMainFileId
  } = useUploadLogoFile({
    logoFiles: passportMainFiles,
    setLogoError: setPassportMainFilesError,
    setIsFirstLoadingFile,
    urlHelperFile,
    setLogoFiles: setPassportMainFiles,
    fileType: FileTypeEnum.PassportMain,
    questionnaireType: questionnaireTypeForFileUpload,
    questionnaireUid: clientId,
  });

  const {
    filesId: passportRegistrationFileId,
    setFilesId: setPassportRegistrationFileId,
    isLoading: isLoadingPassportRegistrationFile
  } = useUploadLogoFile({
    logoFiles: passportRegistrationFiles,
    setLogoError: setPassportRegistrationFilesError,
    setIsFirstLoadingFile,
    urlHelperFile,
    setLogoFiles: setPassportRegistrationFiles,
    fileType: FileTypeEnum.PassportRegistration,
    questionnaireType: questionnaireTypeForFileUpload,
    questionnaireUid: clientId,
  });


  /** ------ end ------ */

  /** ------ Сохраняем в черновик отправленные файла по id ------ */
  const [isLoadingAttachmentsDetails, setIsLoadingAttachmentsDetails] = useState(false);

  const isPartnerTypeQuestionnaires = getTypeQuestionnaires() === "partner";
  // Надо рефакторинг всего этого дела связанного с разделением анкет на партнеров и клиентов
  const keyFieldFile1 = isPartnerTypeQuestionnaires ? NamesOfFieldEnum.PassportMainFileId : NamesOfFieldEnum.LogoFileId;
  const keyFieldFile2 = isPartnerTypeQuestionnaires
    ? NamesOfFieldEnum.PassportRegistrationFileId
    : NamesOfFieldEnum.PassportFileId;

  const postDraftAttachmentsDetails = isPartnerTypeQuestionnaires
    ? postDraftAttachmentsDetailsPartner
    : postDraftAttachmentsDetailsCustomer;

  const handleRequestAttachmentsDetails = useCallback(
    async ({ orgType }: { orgType: OrgTypeEnum }) => {
      try {
        const validationResult = validateUrl('Введите корректный URL, начинающийся с https://')(textLinkAttachment);

        if (validationResult) {
          setPricesTariffsLinkError({
            has: 1,
            message: validationResult
          });
          return 0;
        }

        setIsLoadingAttachmentsDetails(true);

        const responsePostDraftAttachmentsDetails = await postDraftAttachmentsDetails({
          data: {
            id: cleanText(clientId),
            ui_version: "v1",
            is_presave_mode: false,
            fields: {
              ...(passportMainFileId?.length && {
                [NamesOfFieldEnum.PassportMainFileId]: cleanText(passportMainFileId[0])
              }),
              ...(passportRegistrationFileId?.length && {
                [NamesOfFieldEnum.PassportRegistrationFileId]: cleanText(passportRegistrationFileId[0])
              }),
              // ...(passportFileId?.length && {
              //   [keyFieldFile2]: isPartnerTypeQuestionnaires ? passportFileId[0] : passportFileId
              // }),
              ...(documentAgreement1FileId?.length && !isPartnerTypeQuestionnaires && {
                [NamesOfFieldEnum.DocumentAgreement1FileId]: cleanText(documentAgreement1FileId[0])
              }),
              ...(documentAgreement2FileId?.length && !isPartnerTypeQuestionnaires && {
                [NamesOfFieldEnum.DocumentAgreement2FileId]: cleanText(documentAgreement2FileId[0])
              }),
              ...(documentPricesTariffsFileId?.length && !isPartnerTypeQuestionnaires && {
                [NamesOfFieldEnum.DocumentPricesTariffsFileId]: cleanText(documentPricesTariffsFileId[0])
              }),
              ...(textLinkAttachment && {
                [NamesOfFieldEnum.DocumentPricesTariffsLink]: sanitizeURL(textLinkAttachment)
              }),
              [NamesOfFieldEnum.OrgType]: orgType,
              // [NamesOfFieldEnum.IsOffertAccepted]: isAcceptPolitics ? 1 : 0, // оферта сохраняется отдельно
              // privacy-чекбокс убран из partner-UI по ТЗ https://jira.tasktracker.help/browse/LKP-3640
              ...(isPartnerTypeQuestionnaires ? {} : {
                [NamesOfFieldEnum.IsPrivacyAccepted]: isAcceptPrivacy ? 1 : 0,
              }),
              [NamesOfFieldEnum.IsPromoAccepted]: isAcceptPromo ? 1 : 0,
            }
          }
        });
        setIsLoadingAttachmentsDetails(false);
        if (
          responsePostDraftAttachmentsDetails?.success === 0 &&
          responsePostDraftAttachmentsDetails?.errors &&
          responsePostDraftAttachmentsDetails.errors.length > 0
        ) {
          getErrorAttachmentDetails(responsePostDraftAttachmentsDetails.errors, {
            setLogoError,
            setPassportError,
            setDocumentAgreement1Error,
            setDocumentAgreement2Error,
            setDocumentPricesTariffsError,
            setPassportMainFilesError,
            setPassportRegistrationFilesError,
            setPricesTariffsLinkError,
            setAcceptPoliticsError,
            setAcceptPrivacyError,
          });
          return 0; // возвращаем статус ошибки валидации
        }
      } catch (error) {
        throw error;
      }
    },
    [logoFileId, passportFileId, documentAgreement1FileId, documentAgreement2FileId, documentPricesTariffsFileId, textLinkAttachment, passportMainFileId, passportRegistrationFileId, isAcceptPolitics, isAcceptPrivacy, isAcceptPromo]
  );
  /** ------ end ------ */

  const deleteQuestionnaireFile = useCallback(
    (fileId: number, fileType: FileTypeEnum) => {
      clientApi
        .post("/api/questionnaire/v1/helper/file/delete", {
          file_id: fileId,
          file_type: fileType,
          questionnaire_uid: clientId
        })
        .catch(() => {});
    },
    [clientId]
  );


  useEffect(() => {
    if (isFirstLoadingFile) {
      postDraftAttachmentsDetails({
        data: {
          id: cleanText(clientId),
          ui_version: "v1",
          is_presave_mode: true,
          fields: {
            // ...(isPartnerTypeQuestionnaires && {
            //   [keyFieldFile1]: logoFileId[0],
            //   [keyFieldFile2]: passportFileId[0],

            // }),
            [NamesOfFieldEnum.DocumentAgreement1FileId]: documentAgreement1FileId?.length ? cleanText(documentAgreement1FileId[0]) : null,
            [NamesOfFieldEnum.DocumentAgreement2FileId]: documentAgreement2FileId?.length ? cleanText(documentAgreement2FileId[0]) : null,
            [NamesOfFieldEnum.DocumentPricesTariffsFileId]: documentPricesTariffsFileId?.length ? cleanText(documentPricesTariffsFileId[0]) : null,
            [NamesOfFieldEnum.PassportMainFileId]: passportMainFileId?.length ? cleanText(passportMainFileId[0]) : null,
            [NamesOfFieldEnum.PassportRegistrationFileId]: passportRegistrationFileId?.length ? cleanText(passportRegistrationFileId[0]) : null,
            [NamesOfFieldEnum.OrgType]: orgType,
            // [NamesOfFieldEnum.IsOffertAccepted]: isAcceptPolitics ? 1 : 0, // оферта сохраняется отдельно
            // privacy-чекбокс убран из partner-UI по ТЗ https://jira.tasktracker.help/browse/LKP-3640
            ...(isPartnerTypeQuestionnaires ? {} : {
              [NamesOfFieldEnum.IsPrivacyAccepted]: isAcceptPrivacy ? 1 : 0,
            }), [NamesOfFieldEnum.IsPromoAccepted]: isAcceptPromo ? 1 : 0,
          }
        }
      });
    }
  }, [logoFileId, passportFileId, documentAgreement1FileId, documentAgreement2FileId, documentPricesTariffsFileId, passportMainFileId, passportRegistrationFileId])

  return {
    isLoadingMount: isLoading,
    isLoadingLogo: isLoadingUploadLogoFile,
    isLoadingPassport: isLoadingUploadPassportFile,
    isLoadingAttachmentsDetails,
    isErrorAttachmentsDetails,
    logoFileId,
    logoFiles,
    setLogoFileId,
    setLogoFiles,
    passportFileId,
    passportFiles,
    setPassportFileId,
    setPassportFiles,
    handleRequestAttachmentsDetails,
    logoError,
    passportError,
    setLogoError,
    setPassportError,
    setIsFirstLoadingFile,
    isLoadingDocumentAgreement1File: isLoadingUploadDocumentAgreement1File,
    isLoadingDocumentAgreement2File: isLoadingUploadDocumentAgreement2File,
    isLoadingDocumentPricesTariffsFile: isLoadingUploadDocumentPricesTariffsFile,
    documentAgreement1FileId,
    documentAgreement2FileId,
    documentPricesTariffsFileId,
    documentAgreement1Files,
    documentAgreement2Files,
    documentPricesTariffsFiles,
    setDocumentAgreement1Files,
    setDocumentAgreement2Files,
    setDocumentPricesTariffsFiles,
    setDocumentAgreement1FileId,
    setDocumentAgreement2FileId,
    setDocumentPricesTariffsFileId,
    documentAgreement1Error,
    documentAgreement2Error,
    documentPricesTariffsError,
    setDocumentAgreement1Error,
    setDocumentAgreement2Error,
    setDocumentPricesTariffsError,
    passportMainFiles,
    setPassportMainFiles,
    passportRegistrationFiles,
    setPassportRegistrationFiles,
    passportMainFilesError,
    setPassportMainFilesError,
    passportRegistrationFilesError,
    setPassportRegistrationFilesError,
    passportMainFileId,
    passportRegistrationFileId,
    setPassportMainFileId,
    isLoadingPassportMainFileId,
    setPassportRegistrationFileId,
    isLoadingPassportRegistrationFile,
    pricesTariffsLinkError,
    setPricesTariffsLinkError,
    logoData,
    setLogoData,
    deleteQuestionnaireFile
  };
};
